import { api } from "./apiClient";

// Backward-compatible export name. New requests use Inspection Reports endpoints.
export const weeklyReportsAPI = {
  list: (projectId) => api.get(`/projects/${projectId}/inspection-reports`),
  create: (projectId, payload) =>
    api.post(`/projects/${projectId}/inspection-reports`, payload),
  getOne: (projectId, reportId) =>
    api.get(`/projects/${projectId}/inspection-reports/${reportId}`),
  update: (projectId, reportId, payload) =>
    api.patch(`/projects/${projectId}/inspection-reports/${reportId}`, payload),
  generate: (projectId, reportId) =>
    api.post(`/projects/${projectId}/inspection-reports/${reportId}/generate`),
  downloadPdf: (projectId, reportId) =>
    api.get(`/projects/${projectId}/inspection-reports/${reportId}/pdf`, {
      responseType: "blob",
    }),
  periodContext: (projectId, params) =>
    api.get(`/projects/${projectId}/inspection-reports/period-context`, {
      params,
    }),
};
